import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

type Props = {
  value: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'TextEditor',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', f: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string;
}


const content = ref<string>(props.value);


const onEditorChange = (event: any) => {
  emits('input', event.html ?? '');
};
const dummy = async (file: File, type: "Poster" | "Cover" | "Inline") => {
  return 'foo';
};


return { __sfc: true,props, content, emits, onEditorChange, dummy }
}

})